import StationListings from "../../Components/Stations/StationListings"

export default function StationListing() {
    return (
        <StationListings />
    )
}